import { Routes } from '@angular/router';

export const productQueueRoutes: Routes = [
    { path: '', redirectTo: 'list', pathMatch: 'full' },
    {
        path: 'list',
        loadComponent: () =>
            import('./product-queue-listing/product-queue-listing.component').then(
                (m) => m.ProductQueueListingComponent,
            ),
    },
    {
        path: 'verification/:id',
        loadComponent: () =>
            import('./marketing-manager-verification/marketing-manager-verification.component').then(
                (m) => m.MarketingManagerVerificationComponent,
            ),
    },
];
